import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_CLIENT,
  GENERATE_CLIENT_CODE,
  CHANGE_CLIENT_STATUS,
  CHANGE_CLIENT_STATUS_SUCCESS,
  CHANGE_CLIENT_STATUS_FAILURE,
  CREATE_CLIENT_REQUEST,
  DELETE_CLIENT,
  FETCH_ACTIVE_CLIENT_REQUEST,
  FETCH_TIMESHEET_GET_ACCOUNT_LIST,
} from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchClient,
  fetchClientSuccess,
  fetchClientFailure,
  generateClientCode,
  generateClientCodeSuccess,
  generateClientCodeFailure,
  changeClientStatus,
  changeClientStatusSuccess,
  changeClientStatusFailure,
  createClientSuccess,
  createClientFailure,
  deleteClientSuccess,
  deleteClientFailure,
  fetchActiveClient,
  fetchActiveClientSuccess,
  fetchActiveClientFailure,
  fetchAccountList,
  fetchAccountSuccess,
  fetchAccountFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Client
function* fetchClientSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_CLIENT, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client!");
    }
    yield put(fetchClientSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchClientFailure(error.message));
  }
}

function* generateClientCodeSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_GENERATE_CLIENT_CODE, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client code!");
    }
    yield put(generateClientCodeSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(generateClientCodeFailure(error.message));
  }
}

function* changeClientStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_CHANGE_CLIENT_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_CLIENT_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_CLIENT_STATUS_FAILURE, payload: error });
  }
}

// Create Client Saga
// function* createClientSaga({ payload }) {
//   try {
//     const { formData, isEdit } = payload;
//     const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_SAVE_CLIENT, formData);

//     if (response?.status === "success") {
//       Swal.fire({
//         icon: "success",
//         title: "Success",
//         text: response.message || "Client saved successfully!",
//       });
//       yield put(createClientSuccess(response));
//       const unitId = formData.get("unit_id"); 
//       if (unitId) {
//         yield put(fetchClient(unitId));
//       } else {
//         console.log("unit_id is missing in formData, fetch not triggered");
//       }
//     } else {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: response.message || "Something went wrong!",
//       });
//       yield put(createClientFailure("Unexpected response format"));
//     }
//   } catch (error) {
//     console.error("Saga API Error:", error);
//     Swal.fire({
//       icon: "error",
//       title: "API Error",
//       text: error.message || "An error occurred while saving the deduction",
//     });
//     yield put(createClientFailure(error.message));
//   }
// }
function* createClientSaga({ payload }) {
  try {
    const { formData } = payload;
 
    const response = yield call(
      post,
      process.env.REACT_APP_TIMESHEET_SETUP_SAVE_CLIENT,
      formData
    );
 
    if (response?.status?.toLowerCase() === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Client saved successfully!",
      });
 
      yield put(createClientSuccess(response));
 
      const unitId = formData.get("unit_id");
      if (unitId) {
        yield put(fetchClient(unitId));
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
 
      yield put(createClientFailure(response.message));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
 
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the client",
    });
 
    yield put(createClientFailure(error.message));
  }
}

function* deleteClientSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_DELETE_CLIENT, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response.message || "Client deleted successfully!",
      });
      yield put(deleteClientSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete deduction!",
      });
      yield put(deleteClientFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Client Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the deduction",
    });
    yield put(deleteClientFailure(error.message));
  }
}

function* fetchActiveClientSaga(action) {
  console.log('action',action);
  const {unit_id} = action.payload;
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_ACTIVE_CLIENT,formData); // Replace with actual endpoint
    yield put(fetchActiveClientSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchActiveClientFailure(error.message));
  }
}

function* fetchTimesheetAccount(action) {
  console.log('action', action);
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_GET_ACCOUNT_LIST, formData); // Replace with actual endpoint
    yield put(fetchAccountSuccess(response.data));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchAccountFailure(error.message));
  }
}


// Watcher Saga
function* timesheetSetupClientSaga() {
  yield takeEvery(FETCH_CLIENT, fetchClientSaga);  
  yield takeEvery(GENERATE_CLIENT_CODE, generateClientCodeSaga); 
  yield takeEvery(CHANGE_CLIENT_STATUS, changeClientStatusSaga);
  yield takeEvery(CREATE_CLIENT_REQUEST, createClientSaga);
  yield takeEvery(DELETE_CLIENT, deleteClientSaga);
  yield takeEvery(FETCH_ACTIVE_CLIENT_REQUEST, fetchActiveClientSaga); 
  yield takeEvery(FETCH_TIMESHEET_GET_ACCOUNT_LIST, fetchTimesheetAccount); 
}

export default timesheetSetupClientSaga;
